export type WebhookEventName = "ticket.created" | "ticket.status_changed" | "ticket.assignment_changed" | "note.added" | "attachment.added";

export type WebhookDeliveryStatus = "Pending" | "Succeeded" | "Failed" | "FailedTerminal";

export interface Webhook {
  id: string;
  url: string;
  subscribedEvents: string[];
  isEnabled: boolean;
  description?: string;
  departmentIds: number[];
  lastDeliveryAt?: string;
  lastDeliveryStatus?: WebhookDeliveryStatus;
  created: string;
  lastModified: string;
}

export interface WebhookCreated extends Webhook {
  secret: string;
}

export interface WebhookSecret {
  webhookId: string;
  secret: string;
}

export interface WebhookDelivery {
  id: string;
  webhookId: string;
  eventType: string;
  status: WebhookDeliveryStatus;
  attemptCount: number;
  lastAttemptAt?: string;
  lastResponseStatusCode?: number;
  lastError?: string;
  created: string;
}

export interface WebhookCreatePayload {
  url: string;
  subscribedEvents: string[];
  isEnabled: boolean;
  description?: string;
  departmentIds: number[];
}

export interface WebhookUpdatePayload extends WebhookCreatePayload {
  id: string;
}

/**
 * Friendly Romanian labels for the wire-format event names. The wire format remains the canonical
 * identifier sent over the API; these are only for display in the registration form / table.
 */
export const WEBHOOK_EVENT_LABELS: Record<string, string> = {
  "ticket.created": "Tichet creat",
  "ticket.status_changed": "Status modificat",
  "ticket.assignment_changed": "Atribuire modificata",
  "note.added": "Nota adaugata",
  "attachment.added": "Atasament adaugat",
};
